import { render, staticRenderFns } from "./XsltTemplateConfig.vue?vue&type=template&id=8ed0968a&scoped=true"
import script from "./XsltTemplateConfig.vue?vue&type=script&lang=js"
export * from "./XsltTemplateConfig.vue?vue&type=script&lang=js"
import style0 from "./XsltTemplateConfig.vue?vue&type=style&index=0&id=8ed0968a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed0968a",
  null
  
)

export default component.exports